import type { ActionTree } from 'vuex';
import { EntityService } from '@signing-page/api/entity/services/entity.service';
import { mutationSetEntity } from '@signing-page/entity/store/entity.mutations';
import type { IEntityState } from '@signing-page/entity/store/entity.store';
import type { IEntity } from '@signing-page/entity/types/entity';
import type { IRootState } from '@signing-page/store/store';

export const actionLoadEntity = 'loadEntity';
export const actionLoadEntitySuccess = 'loadEntitySuccess';
export const actionLoadEntityFailed = 'loadEntityFailed';

export const actions: ActionTree<IEntityState, IRootState> = {
  async [actionLoadEntity]({ dispatch }) {
    try {
      const entity: IEntity = await EntityService.getEntity();
      dispatch(actionLoadEntitySuccess, entity);
    } catch (e) {
      dispatch(actionLoadEntityFailed, e);
    }
  },
  [actionLoadEntitySuccess]({ commit }, entity: IEntity) {
    commit(mutationSetEntity, entity);
  },
  [actionLoadEntityFailed](_, e: Error) {
    console.error(e);
  },
};
